module.exports = __webpack_public_path__ + "static/media/drop_file_upload.614d84ff.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/drop_file_upload.mp4
// module id = 260
// module chunks = 0